import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText, Icon, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { getThemeImages, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getThemeImages as getSohoThemeImages } from '../../../../Themes';
import SohoFrameworkTestKeys from '../../../../Utils/SohoFrameworkTestKeys';
import UsageViewItem from '../UsageViewItem';

import styles from './UserCard.Styles';

function UserCard({
  name,
  usageData,
  images,
  icon,
  onRemoveUserPress,
  onViewProfilePress,
  containerStyle,
  removeUserIconStyle,
  removeUserTextStyle,
  removeUserContainerStyle,
  userIconStyle,
  withRemoveUser,
  id,
  ...props
}) {
  const theme = useTheme();
  const SohoImages = getSohoThemeImages(theme.name);
  const FoundationImages = getThemeImages(theme.name);

  return (
    <View style={[styles.containerStyle(theme), containerStyle]}>
      <View style={styles.rowContainerStyle}>
        <View style={styles.nameAndIconContainerStyle}>
          <Icon
            name={icon ? images?.[icon] : FoundationImages.ic_indicators_admin}
            size={34}
            style={[styles.userIconStyle, userIconStyle]}
          />
          <VFText
            i18nKey={name}
            testID={SohoFrameworkTestKeys.PlanUserNameTitle}
            type="primary"
            style={styles.nameTextStyle}
          />
        </View>
        {withRemoveUser ? (
          <TouchableOpacity
            style={[styles.removeUserContainerStyle, removeUserContainerStyle]}
            onPress={onRemoveUserPress}
            testID={SohoFrameworkTestKeys.PlanRemoveUserBtn}
          >
            <VFText
              i18nKey={'soho_plans_plan_user_card_remove_label'}
              style={[styles.removeUserTextStyle(theme), removeUserTextStyle]}
            />
            <Icon
              size={20}
              name={SohoImages.ic_Delete_Red}
              style={[styles.removeUserIconStyle, removeUserIconStyle]}
            />
          </TouchableOpacity>
        ) : null}
      </View>
      {usageData ? (
        <UsageViewItem
          {...usageData}
          shouldShowAddUsageButton={false}
          containerStyle={styles.usageViewItemContainerStyle}
        />
      ) : null}
      <View style={styles.divider(theme)} />
      <VFButton
        title={'soho_plans_plan_user_card_view_profile_label'}
        type="secondary"
        style={styles.viewProfileButtonStyle}
        onPress={onViewProfilePress}
        textStyle={styles.viewProfileButtonTextStyle}
        testKey={SohoFrameworkTestKeys.PlanViewProfileBtn}
      />
    </View>
  );
}

UserCard.defaultProps = {
  withRemoveUser: true,
};

UserCard.propTypes = {
  id: PropTypes.string.isRequired,
  role: PropTypes.string,
  name: PropTypes.string,
  '@type': PropTypes.string,
  '@referredType': PropTypes.string,
  usageData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      usageType: PropTypes.string,
      icon: PropTypes.string,
      isUnlimited: PropTypes.bool,
      totalAmount: PropTypes.number,
      totalUnits: PropTypes.string,
      usedAmount: PropTypes.number,
      usedUnits: PropTypes.string,
    }),
  ),
  icon: PropTypes.string,
  onRemoveUserPress: PropTypes.func,
  onViewProfilePress: PropTypes.func,
  images: PropTypes.object,
  containerStyle: ViewPropTypes.style,
  removeUserIconStyle: Icon.propTypes.style,
  removeUserTextStyle: TextPropTypes.style,
  removeUserContainerStyle: ViewPropTypes.style,
  userIconStyle: Icon.propTypes.style,
  withRemoveUser: PropTypes.bool,
};

export default UserCard;
